import Table from './Table';
import TableHead from './head';
import TableBody from './body';
import TableTh from './th';
import TableTr from './tr';
import TableTd from './td';
export { Table, TableHead, TableBody, TableTr, TableTh, TableTd };
//# sourceMappingURL=index.js.map